import apiClient from '../api/apiClient';

export interface DomainAvailabilityRequest {
  email?: string;
  employee_id?: string;
  phone?: string;
}

export interface DomainAvailabilityResponse {
  exists: boolean;
  conflicts: {
    email_domain?: boolean;
    email_user?: boolean;
    employee_id?: boolean;
    phone?: boolean;
  };
  details: {
    email_domain?: string;
    email_user?: string;
    employee_id?: string;
    phone?: string;
  };
}

export class DomainAvailabilityService {
  async checkAvailability(
    data: DomainAvailabilityRequest
  ): Promise<DomainAvailabilityResponse> {
    if (!data.email && !data.employee_id && !data.phone) {
      throw new Error('At least one field (email, employee_id, or phone) must be provided');
    }

    const { data: responseData } = await apiClient.post<DomainAvailabilityResponse>(
      '/admin/domains/check',
      data,
    );
    return responseData;
  }

  async checkEmail(email: string): Promise<DomainAvailabilityResponse> {
    return this.checkAvailability({ email });
  }

  async checkEmployeeId(employeeId: string): Promise<DomainAvailabilityResponse> {
    return this.checkAvailability({ employee_id: employeeId });
  }

  async checkPhone(phone: string): Promise<DomainAvailabilityResponse> {
    return this.checkAvailability({ phone });
  }
}

export const domainAvailabilityService = new DomainAvailabilityService();
